import { render, staticRenderFns } from "./SurveyLayout.vue?vue&type=template&id=32be3ac3&scoped=true&"
import script from "./SurveyLayout.vue?vue&type=script&lang=ts&"
export * from "./SurveyLayout.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyLayout.vue?vue&type=style&index=0&id=32be3ac3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32be3ac3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
